'use client'
import cn from 'classnames'
import { observer } from 'mobx-react-lite'
import dynamic from 'next/dynamic'
import { FunctionComponent, useEffect, useState } from 'react'

import { ToggleButtonGroup } from '@/components/ToggleButtonGroup'
import { AutoClassSearch } from './components/AutoClassSearch'

import { mktuClassListStore } from '@/store/MktuClassList.store'
import styles from './Mktu.module.scss'

const ManualClassSearch = dynamic(() =>
  import('./components/ManualClassSearch').then((m) => m.ManualClassSearch)
)

enum MktuSearchType {
  Auto = 'Auto',
  Manual = 'Manual',
}

const MktuSearchTabs = [
  {
    value: MktuSearchType.Auto,
    name: 'Автоматический подбор',
  },
  {
    value: MktuSearchType.Manual,
    name: 'Подбор вручную',
  },
]
type MktuProps = {
  className?: string
}
export const Mktu: FunctionComponent<MktuProps> = observer(({ className }) => {
  const [searchType, setSearchType] = useState(MktuSearchType.Auto)

  useEffect(() => {
    mktuClassListStore.getClasses()
  }, [])

  return (
    <div className={cn(className, styles.container)}>
      <div className={styles.title}>Подберите классы МКТУ</div>
      <ToggleButtonGroup
        list={MktuSearchTabs}
        value={searchType}
        onChange={setSearchType}
        className={styles.searchTypeButtons}
      />
      {searchType === MktuSearchType.Manual ? (
        <ManualClassSearch
          className={styles.classes}
          productClass={mktuClassListStore.producClass}
          serviceClass={mktuClassListStore.servicesClass}
        />
      ) : null}
      {searchType === MktuSearchType.Auto ? (
        <AutoClassSearch className={styles.classes} />
      ) : null}
    </div>
  )
})
